import AlertModal from './AlertModal';
import EditModal from './EditModal';
import ModalWithConfirm from './ModalWithConfirm';
import AddTicketModal from './AddTicketModal';
import Modal from './Modal';
import CleanModal from './CleanModal';
import ConfirmationModal from './ConfirmationModal';
import ModalWithSubmitConfirm from './ModalWithSubmitConfirm';
import { BasicModal } from './BasicModal';

const ModalTypes = {
  ALERT_MODAL: AlertModal,
  EDIT_MODAL: EditModal,
  MODAL_WITH_CONFIRM: ModalWithConfirm,
  TICKET_MODAL: AddTicketModal,
  GENERIC_MODAL: Modal,
  CLEAN_MODAL: CleanModal,
  CONFIRMATION_MODAL: ConfirmationModal,
  MODAL_WITH_SUBMIT_CONFIRM: ModalWithSubmitConfirm,
  BASIC_MODAL: BasicModal
};

export default ModalTypes;
